import { GCPLog, LogsListResponse, ProfinderLog } from '@engine/models/admin'

import { adminFetch } from '#api/client.js'
import { CopyRequestButton } from '#components/CopyRequestButton.js'

interface CopyProfinderRequestButtonProps {
  log: ProfinderLog
}

/**
 * The request payload lives on the trace's `profinder request` log entry, not on
 * the result log the slider is built from.
 */
export const CopyProfinderRequestButton = ({
  log,
}: CopyProfinderRequestButtonProps) => (
  <CopyRequestButton
    label="Copy Profinder Request"
    getContent={async () => {
      const { items } = await adminFetch<LogsListResponse<GCPLog>>(
        'profinder-logs',
        { params: { trace: log.trace, limit: 500 } },
      )

      const request = items.find(item => item.message === 'profinder request')
      if (!request) {
        throw new Error('No profinder request found for this trace')
      }

      return request.data
    }}
  />
)
